import { LoadingSpinner } from '../utils/LoadingSpinner';

interface GMessagesTableProps {
    messages: any[];
    loading?: boolean;
    error?: string | null;
    user?: any;
}

export default function GMessagesTable({ messages, loading = false, error = null }: GMessagesTableProps) {
    const cols = messages.length > 0 ? Object.keys(messages[0]) : [];

    if (loading) return <LoadingSpinner text="Loading messages..." />;
    if (error) return <LoadingSpinner text={error} />;

    if (messages.length === 0) {
        return (
            <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                <div style={{ fontSize: 18, marginBottom: 8 }}>No messages found</div>
                <div style={{ fontSize: 14 }}>There are no messages matching your filter or user.</div>
            </div>
        );
    }

    return (
        <table className='elegant-table' border={1} cellPadding={8}>
            <thead>
                <tr>
                    {cols.map((c) => (
                        <th key={c}>{c}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {messages.map((row, i) => (
                    <tr key={row.id ?? row.message_id ?? i}>
                        {cols.map((col) => (
                            <td key={`${i}-${col}`}>{row[col] === null || row[col] === undefined ? '—' : String(row[col])}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
